import { createTheme, colors } from '@mui/material';
import { deDE } from '@mui/material/locale';

export const theme = createTheme(
  {
    palette: {
      primary: {
        main: '#02344C',
      },
      secondary: {
        main: '#ffc107',
      },
      background: {
        default: colors.grey[100],
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
    components: {
      MuiPopover: {
        defaultProps: {
          container: document.getElementById('root'),
        },
      },
      MuiPopper: {
        defaultProps: {
          container: document.getElementById('root'),
        },
      },
    },
  },
  deDE,
);

export const internalTheme = createTheme(
  {
    palette: {
      primary: {
        main: '#02344C',
      },
      secondary: {
        main: '#ffc107',
      },
      background: {
        paper: '#fafafa',
        default: '#ffffff',
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
    components: {
      MuiPopover: {
        defaultProps: {
          container: document.getElementById('root'),
        },
      },
      MuiPopper: {
        defaultProps: {
          container: document.getElementById('root'),
        },
      },
    },
  },
  deDE,
);
